/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputCompleteWebAuthnRegistrationRequest
 */
export interface InputCompleteWebAuthnRegistrationRequest {
    /**
     * JSON string from navigator.credentials.create()
     * @type {string}
     * @memberof InputCompleteWebAuthnRegistrationRequest
     */
    credential: string;
    /**
     * Optional name for the credential
     * @type {string}
     * @memberof InputCompleteWebAuthnRegistrationRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the InputCompleteWebAuthnRegistrationRequest interface.
 */
export function instanceOfInputCompleteWebAuthnRegistrationRequest(value: object): boolean {
    if (!('credential' in value)) return false;
    return true;
}

export function InputCompleteWebAuthnRegistrationRequestFromJSON(json: any): InputCompleteWebAuthnRegistrationRequest {
    return InputCompleteWebAuthnRegistrationRequestFromJSONTyped(json, false);
}

export function InputCompleteWebAuthnRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputCompleteWebAuthnRegistrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'credential': json['credential'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InputCompleteWebAuthnRegistrationRequestToJSON(value?: InputCompleteWebAuthnRegistrationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credential': value['credential'],
        'name': value['name'],
    };
}

